export default {
      id: "oc-icon_stop-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_stop",
      toString: function () {
        return this.url;
      }
    }